import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { useTranslation } from 'react-i18next';
import images from '../../assets/Images';
import { COLORS } from '../../colors';

const FooterSection: React.FC = React.memo(() => {
  const { t } = useTranslation();
  
  const footerLinks = [
    { key: 'privacyPolicy', text: t('footer.privacyPolicy', 'Privacy Policy') },
    { key: 'gdpr', text: t('footer.gdpr', 'GDPR') },
    { key: 'privacyRights', text: t('footer.privacyRights', 'Privacy Rights') },
    { key: 'feeInformation', text: t('footer.feeInformation', 'Fee Information') },
    { key: 'termsOfUse', text: t('footer.termsOfUse', 'Terms of Use') },
    { key: 'doNotSell', text: t('footer.doNotSell', 'Do Not Sell My Personal Information') },
    { key: 'lawEnforcement', text: t('footer.lawEnforcement', 'Law Enforcement Requests') },
  ];
  return (
    <Box
      sx={{
        width: '100%',
        px: { xs: 1, sm: 3 },
        py: { xs: 2, sm: 3 },
        bgcolor: COLORS.darkGray,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: { xs: 1, sm: 2 },
        mt: { xs: 2, sm: 6 },
      }}
      component="footer"
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          flexWrap: 'wrap',
          justifyContent: { xs: 'center', sm: 'space-between' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          gap: { xs: 2, sm: 0 },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 }, mb: { xs: 2, sm: 0 }, justifyContent: { xs: 'center', sm: 'flex-start' }, width: { xs: '100%', sm: 'auto' } }}>
          <Box
            sx={{ width: { xs: 48, sm: 63.81 }, height: 24, position: 'relative', overflow: 'hidden', mr: { xs: 1, sm: 2 } }}
          >
            <img
              src={images.FooterImg}
              alt="Hertz Logo"
              style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
            />
          </Box>
          <Typography
            sx={{ color: 'white', fontSize: { xs: 12, sm: 14 }, fontFamily: 'Open Sans', fontWeight: 400, lineHeight: '21px' }}
          >
            {t('footer.copyright', '©2023 DTG Operations, Inc.')}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 }, flexWrap: 'wrap', justifyContent: { xs: 'center', sm: 'flex-end' }, width: { xs: '100%', sm: 'auto' } }}>
          {footerLinks.map((link, idx) => (
            <React.Fragment key={link.key}>
              <Typography
                sx={{ color: 'white', fontSize: { xs: 12, sm: 14 }, fontFamily: 'Open Sans', fontWeight: 400, lineHeight: '21px', whiteSpace: 'nowrap' }}
              >
                {link.text}
              </Typography>
              {idx < footerLinks.length - 1 && (
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ borderColor: 'white', height: 18, mx: { xs: 0.5, sm: 1 } }}
                />
              )}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </Box>
  );
});

export default FooterSection;